import { AVATAR_COLORS } from '../constants';

/**
 * Get initials from a full name (up to 2 characters)
 * @param name - The full name to extract initials from
 * @returns Uppercase initials string
 */
export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return (name[0] ?? '').toUpperCase();
}

/**
 * Get a consistent avatar background color based on a string (typically email)
 * @param str - The string to generate color from (usually email)
 * @returns A hex color code
 */
export function getAvatarColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
